import Vue from 'vue';
import 'vuetify/dist/vuetify.min.css';
import Vuetify from 'vuetify';
import colors from 'vuetify/lib/util/colors';
import { VuetifyPreset } from 'vuetify/types/services/presets';
import Lib from 'vuetify/lib';
import { GrowmarkColorPalette } from '../constants/colors';

Vue.use(Vuetify);


Lib.config.silent = !['local'].find(env => process.env.NODE_ENV === env);
const options: VuetifyPreset = { //https://vuetifyjs.com/en/features/presets/#default-preset
  breakpoint: {
    mobileBreakpoint: 'xs',
    scrollBarWidth: 16,
    thresholds: {
      xs: 600,
      sm: 960,
      md: 1280,
      lg: 1920,
    }
  },
  icons: {
    iconfont: 'mdi',
    values: { }
  },
  lang: {
    t: () => '',
    locales: {},
    current: 'en'
  },
  rtl: false,
  theme: {
    dark: false,
    default: 'light',
    disable: false,
    options: {
      //cspNonce: undefined,
      customProperties: true,
      //minifyTheme: undefined,
      //themeCache: undefined,
    },
    themes: {
      light: {
        /* custom colors and specify colors */
        primary: GrowmarkColorPalette.Blue.Light,
        secondary: GrowmarkColorPalette.Gray.Light,
        unbranded: GrowmarkColorPalette.Unbranded.Light,
        destroy: GrowmarkColorPalette.Orange.Light, //clears out input user has entered
        undo: GrowmarkColorPalette.Orange.Light, //undoes a users recent action
        more: GrowmarkColorPalette.Blue.Light,
        accent: GrowmarkColorPalette.Blue.Light,
        error: GrowmarkColorPalette.Red.Light,
        info: GrowmarkColorPalette.Blue.Light,
        success: GrowmarkColorPalette.Green.Light,
        warning: GrowmarkColorPalette.Orange.Light,
      },
      dark: {
        primary: GrowmarkColorPalette.Blue.Dark,
        secondary: GrowmarkColorPalette.Gray.Dark,
        unbranded: GrowmarkColorPalette.Unbranded.Dark,
        destroy: GrowmarkColorPalette.Orange.Dark, //clears out input user has entered
        undo: GrowmarkColorPalette.Orange.Dark, //undoes a users recent action
        more: GrowmarkColorPalette.Blue.Dark, //blue
        accent: GrowmarkColorPalette.Blue.Dark,
        error: GrowmarkColorPalette.Red.Dark,
        info: GrowmarkColorPalette.Blue.Dark,
        success: GrowmarkColorPalette.Green.Dark,
        warning: GrowmarkColorPalette.Orange.Dark,
      },
    }
  }
};
const vuetify = new Vuetify(options);
export default vuetify;